/** Tier-1 operational-data disclosure shown at the bootstrap consent stop and
 *  echoed on the onboarding UI. Kept in lockstep with TELEMETRY.md.
 *
 *  This text is m8t-owned and hand-written — it is NOT part of the vendored
 *  contract artifact and no generator produces it. Edit it here, and keep
 *  TELEMETRY.md saying the same thing.
 *
 *  It must never describe the installation as anonymous: the id is persistent,
 *  which makes it pseudonymous. A test enforces that. */
export const DISCLOSURE_TIER1 =
  "Operational data. To support your installation, m8t receives limited " +
  "operational data linked to it — installation and update events, installed " +
  "versions, and service health signals. Your installation is identified only " +
  "by a random installation ID we generate at setup — an opaque value with no " +
  "information encoded in it. No name, email, company, or subscription " +
  "information is sent in the enrollment record unless you explicitly choose " +
  "to share contact details for support. At enrollment, we also verify a " +
  "cloud identity token to confirm the request comes from a real cloud " +
  "account; that token names the account making the request, and is " +
  "otherwise discarded immediately and never stored. This is service data " +
  "used only to operate and support the platform; it contains none of your " +
  "content. After setup, you can turn this off in the web app's Settings, " +
  "under Privacy; update checks keep working. Details: TELEMETRY.md.";

/** Which revision of the notice above a consent decision was made against.
 *
 *  Bump whenever DISCLOSURE_TIER1 changes: a stored consent record names this
 *  value, and a record pointing at text nobody saw is worse than no record at
 *  all. The digest below pins the pairing, so the bump cannot be forgotten.
 *
 *  Format is YYYY-MM-DD.N - the date the text changed, then a same-day serial. */
export const DISCLOSURE_VERSION = "2026-07-25.1";

/** What each notice revision said, as sha256 of its text (first 16 hex).
 *
 *  Keyed BY VERSION, and append-only. A single pinned digest would not do the
 *  job it looks like it does: editing the notice and updating that one digest
 *  leaves the guard green while DISCLOSURE_VERSION still points at text nobody
 *  saw. Keyed by version, changing the text means the CURRENT version's entry
 *  stops matching, and the only correct repair is a NEW version with a new
 *  entry - which is exactly the bump the guard exists to force.
 *
 *  Never edit an existing entry. Add one. Entries for past versions are a
 *  record of what was shown to people who consented under them, and their
 *  digests cannot be recomputed from anything in this file.
 *
 *  Deliberately not exported: the guard reads these literals out of the source,
 *  because a digest computed at runtime would agree with itself forever. */
const DISCLOSURE_TEXT_DIGESTS: Record<string, string> = {
  "2026-07-25.1": "d1dc32e7f65fe6cb",
};
void DISCLOSURE_TEXT_DIGESTS;
